var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.userRole === 'Admin')?_c('admin-home'):(_vm.user.userRole === 'Affiliate')?_c('affiliate-home'):_c('user-home')}
var staticRenderFns = []

export { render, staticRenderFns }